module.exports = (el, binding, vnode) => {
  const currentRouter = vnode.componentInstance
    ? vnode.componentInstance.$router
    : vnode.context.$router;

  if (!currentRouter.canSee(binding.value)) {
    // Implement v-if directive
    const comment = document.createComment(' ');
    Object.defineProperty(comment, 'setAttribute', {
      value: () => undefined,
    });
    /* eslint-disable no-param-reassign */
    vnode.elm = comment;
    vnode.text = ' ';
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;

    if (vnode.componentInstance) {
      vnode.componentInstance.$el = comment;
    }
    /* eslint-enable no-param-reassign */

    if (el.parentNode) {
      el.parentNode.replaceChild(comment, el);
    }
  }
};



// WEBPACK FOOTER //
// ./src/helpers/grantedDirective.js